import { NewsList as News } from './NewsList'
import { OpportunitiesList as Opportunities } from './OpportunitiesList'
import { OpportunitiesListOfCard } from './OpportunitiesListOfCard'
import { OpportunitiesListV2 as OpportunitiesV2 } from './OpportunitiesListV2'
import { SummaryList as Summary } from './SummaryList'

export default { News, Opportunities, OpportunitiesV2, OpportunitiesListOfCard, Summary }
